export default "/images/33bd31f3fd213bf7eebe879e0c148e62.avif";